import { createContext, useContext } from 'react'
import type { SendMessageOptions } from 'tripPlanner/components/AddToTrip/useAddHotelToTrip'

export interface ChatActionsValue {
  submitMessage: (message: string, options?: { messageType?: string }) => Promise<void>
  sendMessage: (message: string, options?: SendMessageOptions) => Promise<void>
  regenerateResponse: () => Promise<void>
  stopStreaming: () => Promise<boolean>
  resetConversation: (options?: { followTail?: boolean }) => void
  resetStreamingState: () => void
  setFollowTail: React.Dispatch<React.SetStateAction<boolean>>
  retryLastMessage: () => Promise<void>
}

export const ChatActionsContext = createContext<ChatActionsValue | null>(null)

export function useChatActions(): ChatActionsValue {
  const ctx = useContext(ChatActionsContext)
  if (!ctx) throw new Error('useChatActions must be used within TripPlannerChatProvider')
  return ctx
}
